import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { EntityStaff } from "../../entity/EntityStaff";

export class DtoStaffsGetRes extends EntityStaff {
  public items: EntityStaff[]  = [];
}
